import React, { useState, memo, useCallback } from 'react';
import { ImageCircularUploaderItem } from '@redlink/components/molecules';
import { useMutation, uploadQuery } from '@redlink/services';

export const ImageCircularUploaderSimple = memo(
  ({ disabled = false, onUpload, value, thumbnail, size = 75 }) => {
    const [status, setStatus] = useState(
      value
        ? ImageCircularUploaderItem.status.selected
        : ImageCircularUploaderItem.status.none
    );
    const [selectedImageName, setSelectedImageName] = useState(value);
    const [progress, setProgress] = useState(0);

    const [upload] = useMutation(uploadQuery, {
      done: async ({ Upload: { id, thumbnailUrl } }) => {
        onUpload && onUpload({ id, thumbnailUrl });
      },
      failed: () => {
        setStatus(ImageCircularUploaderItem.status.none);
        setSelectedImageName('');
      },
      context: {
        fetchOptions: {
          useUpload: true,
          onProgress: (ev) => {
            setProgress((ev.loaded / ev.total) * 100);
          },
          onAbortPossible: () => {
            setStatus(ImageCircularUploaderItem.status.selected);
          },
        },
      },
    });

    const onChange = useCallback(
      ([file]) => {
        if (file) {
          setStatus(ImageCircularUploaderItem.status.busy);
          setSelectedImageName(file.name);
          upload({ file });
        }
      },
      [upload]
    );

    return (
      <ImageCircularUploaderItem
        size={size}
        {...{ status, progress, thumbnail, onChange, disabled }}
      />
    );
  }
);
